import { APP_ENVIRONMENT_CONSTANTS } from 'common/constants/appEnvironmentConstants'
import { env } from 'common/utils/env'

export enum BOOKING_STATUS_CODE {
  ACTIVE = 1,
  CANCELLED = 2,
  FINISHED = 10,
  WAITING_TO_SIGN = 12,
}

// Problem List picker in the EHR book appointment dialog; dev-only until released
export const SHOW_EHR_APPOINTMENT_MEDICAL_ISSUES = env.ENV === APP_ENVIRONMENT_CONSTANTS.DEVELOPMENT
